<template>
  <div>
    <div></div>
    <!-- Assignment Multi Update Modal Start -->
    <b-button
      style="font-size: 0.675rem"
      class="mt-2"
      size="sm"
      v-if="JOBID != ''"
      @click="changeLocation()"
      :variant="'success'"
    >
      Change Location
    </b-button>

    <b-modal
      id="CngLoc-conf"
      ref="CngLoc-conf"
      :title="m_title"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div class="col-md-2 text-right">
          <label for="ColumnName">Location :</label>
        </div>
        <div class="col-md-10 mt-2">
          <model-list-select
            :list="options1"
            v-model="objectItem"
            option-value="pickupLocation"
            option-text="pickupLocation"
            placeholder="select Location"
          ></model-list-select>
        </div>

        <div class="col-md-12 text-center">
          <center>
            <b-button
              v-if="this.objectItem.BranchCode"
              :disabled="!this.objectItem.BranchCode ? true : false"
              variant="success"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              @click="smbChangeLocation"
              >Send</b-button
            >

            <b-button
              @click="hideChangeLocation"
              style="font-size: 11px"
              size="sm"
              class="mt-2"
              variant="danger"
              >Close</b-button
            >
          </center>
        </div>
      </div>
    </b-modal>
    <!-- Assignment Summary Modal End -->
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    JOBID: {
      type: String,
      default: "",
    },
    JOBNO: {
      type: String,
      default: "",
    },
    JOBDATE: {
      type: String,
      default: "",
    },
    JOBTYPE: {
      type: String,
      default: "",
    },
  },

  beforeMount() {},

  data() {
    return {
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      Filter_Flag: false,

      m_title: this.title,
      JOB_ID: this.JOBID,
      JOB_NO: this.JOBNO,
      JOB_DATE: this.JOBDATE,
      JOB_TYPE: this.JOBTYPE,
      JOB_NO: this.JOBNO,
      objectItem: {},
      options1: [],
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    Loading,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    changeLocation() {
      this.Filter_Flag = true;
      this.$refs["CngLoc-conf"].show();
      this.getLocations();
    },
    hideChangeLocation() {
      this.actionType = "";
      this.$refs["CngLoc-conf"].hide();
    },
    getLocations() {
      const option = {
        data: this.options1,
        categoryType: "hh",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getLocationList.php`,
        data: JSON.stringify(option),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { data } = result;
          this.options1 = data.userDataList;
          this.$refs["location-modal"].show();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    smbChangeLocation() {
      if (this.Filter_Flag == true) {
        let location = this.JOB_NO.split("/");
        if (this.objectItem.BranchCode) {
          let series = `${location[0]}/${location[1]}/${this.objectItem.BranchCode}/${location[3]}/${location[4]}`;

          let payload = {
            categoryType: "hh",
            userId: this.userId ? this.userId : "",
            location: series,
            objectItem: this.objectItem,
            pickupId: this.objectItem.pickupId,
            allModuleId: this.JOB_ID,
            type: location[1],
            newLocation: series.replaceAll("/", "_"),
            oldLocation: this.JOB_NO.replaceAll("/", "_"),
          };
          console.log(payload);
          let options = {
            method: "POST",
            url: `${URL_BASE}/updateLocation.php`,
            data: JSON.stringify(payload),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { data } = result;
              // this.getData();
              if (data.StatusCode == 1) {
                this.hideChangeLocation();
                this.alert.content = data.MSGTxt;
                this.$refs["addPop"].open();
                 eventBus.$emit("StatusCode", data.StatusCode);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// changeLocation.vue?11a86b25